<p mat-dialog-title>Zmiana opiekuna</p>
<mat-dialog-content>
	<mat-form-field appearance="outline" class="w-100 dialog__formField mt-3">
		<mat-label>Wyszukaj opiekuna</mat-label>
		<input type="text" matInput [matAutocomplete]="autoUser" [formControl]="usersSelect" />
		<mat-autocomplete
			#autoUser="matAutocomplete"
			[displayWith]="displayUsersFn.bind(this)"
			(optionSelected)="selectUser($event)"
		>
			<mat-option *ngFor="let user of filteredUsers" [value]="user.id">
				{{ user.firstName }} {{ user.lastName }}
			</mat-option>
		</mat-autocomplete>
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button (click)="dialogRef.close()" mat-raised-button>Porzuć</button>
	<button (click)="submit(usersSelect)" mat-raised-button color="primary">Zmień</button>
</mat-dialog-actions>
